import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {ButtonPrimary, ButtonSecondary, ContentBlock, ContentItem, Icon, infoIcon, Modal, useStyles, Circle} from '@ace-de/ui-components';
import * as invoiceSubmissionActionTypes from '../invoiceSubmissionActionTypes';

const AddInvoiceSubmissionServiceModal = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('add_service_modal');
    const {confirmAddService, declineAddService, hasBackdrop} = props;

    return (
        <Modal
            contentClassName={cx([
                'global!ace-u-flex',
                'global!ace-u-flex--justify-center',
                'global!ace-u-modal-content-size--xs',
            ])}
            hasBackdrop={hasBackdrop}
        >
            <ContentBlock
                className={cx([
                    'global!ace-u-flex',
                    'global!ace-u-flex--direction-column',
                    'global!ace-u-flex--justify-center',
                ])}
            >
                <ContentItem
                    className={cx([
                        'global!ace-u-flex',
                        'global!ace-u-flex--align-center',
                        'global!ace-u-flex--direction-column',
                    ])}
                >
                    <Circle
                        className={cx([
                            'ace-c-circle--small',
                            'global!ace-u-margin--bottom-24',
                        ])}
                    >
                        <Icon
                            icon={infoIcon}
                            className={cx([
                                'ace-c-icon--m',
                                'ace-c-icon--color-highlight',
                            ])}
                        />
                    </Circle>
                    <h2
                        className={cx([
                            'global!ace-u-margin--bottom-16',
                            'global!ace-u-typography--variant-h2',
                            'global!ace-u-typography--align-center',
                        ])}
                    >
                        {translateModal('modal_title.add_service')}
                    </h2>
                    <p
                        className={cx([
                            'global!ace-u-margin--bottom-24',
                            'global!ace-u-typography--align-center',
                            'global!ace-u-typography--variant-body',
                        ])}
                    >
                        {translateModal('modal_body.add_service')}
                    </p>
                    <ButtonPrimary
                        name="addService"
                        className={cx([
                            'global!ace-u-width--full',
                            'global!ace-u-margin--small-bottom-16',
                        ])}
                        onClick={confirmAddService}
                    >
                        {translateModal('button_label.yes')}
                    </ButtonPrimary>
                    <ButtonSecondary
                        name="declineAddService"
                        className={cx([
                            'global!ace-u-width--full',
                        ])}
                        onClick={declineAddService}
                    >
                        {translateModal('button_label.no')}
                    </ButtonSecondary>
                </ContentItem>
            </ContentBlock>
        </Modal>
    );
};

AddInvoiceSubmissionServiceModal.propTypes = {
    hasBackdrop: PropTypes.bool,
    confirmAddService: PropTypes.func.isRequired,
    declineAddService: PropTypes.func.isRequired,
};

AddInvoiceSubmissionServiceModal.defaultProps = {
    hasBackdrop: true,
};

const mapDispatchToProps = dispatch => ({
    confirmAddService: () => dispatch({
        type: invoiceSubmissionActionTypes.CONFIRM_ADD_INVOICE_SUBMISSION_SERVICE,
    }),
    declineAddService: () => dispatch({
        type: invoiceSubmissionActionTypes.DECLINE_ADD_INVOICE_SUBMISSION_SERVICE,
    }),
});

export default connect(null, mapDispatchToProps)(AddInvoiceSubmissionServiceModal);
